"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = exports.Selector = void 0;
const envConfig = require("./configs/env-config");
const ractive_1 = require("ractive");
const SelectorBundler_1 = require("./Widget/Selector/SelectorBundler");
const Environment_1 = require("./Enum/Environment");
const ViewBundler_1 = require("./Widget/View/ViewBundler");
const env = ["dev", "integration", "qa", "preprod", "preprod_spider"]
    .includes(envConfig.ENVIRONMENT.toLowerCase()) ? Environment_1.Environment.DEV : Environment_1.Environment.PROD;
if (env === Environment_1.Environment.DEV) {
    ractive_1.Ractive.DEBUG = true;
}
else {
    // Disable ractive debug logging in production.
    ractive_1.Ractive.DEBUG = false;
}
exports.Selector = Object.freeze(SelectorBundler_1.default.bundle(env));
exports.View = Object.freeze(ViewBundler_1.default.bundle(env));
